import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Topbar from "../../layouts/Topbar";
import Sidebar from "../../layouts/Sidebar";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import axios from "axios";
import { API_BASE_URL } from "../../../config/api";

const quarterOptions = [
  { value: "Q1", label: "Quarter 1" },
  { value: "Q2", label: "Quarter 2" },
  { value: "Q3", label: "Quarter 3" },
  { value: "Q4", label: "Quarter 4" },
  { value: "Quarterly", label: "Quarterly" },
  { value: "Weekly", label: "Weekly" },
  { value: "Bi-Weekly", label: "Bi-Weekly" },
  { value: "Monthly", label: "Monthly" },
  { value: "Semi-Annually", label: "Semi-Annually" },
  { value: "Annually", label: "Annually" },
];

const monthOptions = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

const performanceStandardOptions = [
  { value: "Monthly", label: "MONTHLY" },
  { value: "Quarterly", label: "QUARTELY" },
  { value: "Always", label: "ALWAYS" },
  { value: "As and when necessary", label: "AS AND WHEN NECESSARY" },
  { value: "As and when required", label: "AS AND WHEN REQUIRED" },
  { value: "Daily", label: "DAILY" },
  {
    value: "Annually in line with policies and procedures",
    label: "ANNUALLY IN LINE WITH POLICIES AND PROCEDURES",
  },
  {
    value: "Quarterly accurate records daily",
    label: "QUARTELY ACCURATE RECORDS DAILY",
  },
];

const selectStyles = {
  control: (base) => ({ ...base, minHeight: '38px', borderRadius: '0.375rem' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 })
};

const MyGoals = () => {
  const baseUrl = API_BASE_URL;
  const navigate = useNavigate();
  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedActivities, setExpandedActivities] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedGoal, setSelectedGoal] = useState(null);
  const [progressHistory, setProgressHistory] = useState([]);
  const [progressLoading, setProgressLoading] = useState(false);
  const [progressError, setProgressError] = useState(null);
  const [progressModalOpen, setProgressModalOpen] = useState(false);
  const [progressForm, setProgressForm] = useState({
    status: "in_progress",
    comments: "",
    score: "",
    file: null,
  });
  const [progressSubmitting, setProgressSubmitting] = useState(false);
  const [progressSubmitError, setProgressSubmitError] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editForm, setEditForm] = useState({
    key_result_area: null,
    activity: "",
    metric: "",
    stakeholder: "",
    performance_standard: null,
    quarter: null,
    year: new Date().getFullYear(),
    week: "",
    month: null,
  });
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [availableYears, setAvailableYears] = useState([]);
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [editLoading, setEditLoading] = useState(false);
  const [editError, setEditError] = useState(null);
  const [kras, setKras] = useState([]);
  const [fetchingKRAs, setFetchingKRAs] = useState(false);

  const toggleActivityExpansion = (goalId) => {
    setExpandedActivities((prev) => ({
      ...prev,
      [goalId]: !prev[goalId],
    }));
  };

  const fetchProgressHistory = async (goalId) => {
    setProgressLoading(true);
    setProgressError(null);
    try {
      const token = Cookies.get("token");
      const response = await axios.get(
        `${baseUrl}/api/goals/${goalId}/progress/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data;
      setProgressHistory(Array.isArray(data) ? data : data.results || []);
    } catch (err) {
      setProgressError(err.message || "Could not load progress history");
    } finally {
      setProgressLoading(false);
    }
  };

  const handleViewGoal = (goal) => {
    setSelectedGoal(goal);
    setModalOpen(true);
    fetchProgressHistory(goal.id);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedGoal(null);
  };

  const openProgressModal = () => {
    setProgressForm({
      status: "in_progress",
      comments: "",
      score: "",
      file: null,
    });
    setProgressSubmitError(null);
    setProgressModalOpen(true);
  };

  const closeProgressModal = () => {
    setProgressModalOpen(false);
  };

  const handleProgressFormChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "file") {
      setProgressForm((prev) => ({
        ...prev,
        file: files && files[0] ? files[0] : null,
      }));
      return;
    }
    setProgressForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleProgressSubmit = async (e) => {
    e.preventDefault();
    setProgressSubmitting(true);
    setProgressSubmitError(null);
    try {
      const token = Cookies.get("token");
      await axios.post(
        `${baseUrl}/api/goals/${selectedGoal.id}/progress/`,
        {
          status: progressForm.status,
          comments: progressForm.comments,
          score: progressForm.score,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (progressForm.status === "completed" && progressForm.file) {
        const filePayload = new FormData();
        filePayload.append("performance_goal", selectedGoal.id);
        filePayload.append("document", progressForm.file);

        await axios.post(`${baseUrl}/api/goal-documents/`, filePayload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      }

      setProgressModalOpen(false);
      await fetchProgressHistory(selectedGoal.id);
      const updatedGoalRes = await axios.get(
        `${baseUrl}/api/goals/${selectedGoal.id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const updatedGoal = updatedGoalRes.data;
      setGoals((prevGoals) =>
        prevGoals.map((g) => (g.id === updatedGoal.id ? updatedGoal : g))
      );
      setSelectedGoal(updatedGoal);
    } catch (err) {
      setProgressSubmitError(err.message || "Could not update progress");
    } finally {
      setProgressSubmitting(false);
    }
  };

  const handleDeleteGoal = async (goal) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the goal.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        const token = Cookies.get("token");
        await axios.delete(`${baseUrl}/api/goals/${goal.id}/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setGoals((prevGoals) => prevGoals.filter((g) => g.id !== goal.id));
        Swal.fire("Deleted!", "The goal has been deleted.", "success");
      } catch (err) {
        Swal.fire("Error", err.message || "Failed to delete goal", "error");
      }
    }
  };

  useEffect(() => {
    const fetchKRAs = async () => {
      setFetchingKRAs(true);
      try {
        const token = Cookies.get("token");
        const response = await axios.get(`${baseUrl}/api/key-result-areas/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setKras(response.data);
      } catch (err) {
        // Silently ignore
      } finally {
        setFetchingKRAs(false);
      }
    };
    fetchKRAs();
  }, [baseUrl]);

  const kraOptions = kras.map((kra) => ({ value: kra.id, label: kra.name }));

  const openEditModal = (goal) => {
    let kraOption = null;
    if (goal.key_result_area) {
      if (
        typeof goal.key_result_area === "object" &&
        goal.key_result_area !== null &&
        "id" in goal.key_result_area
      ) {
        kraOption =
          kraOptions.find((k) => k.value === goal.key_result_area.id) || null;
      } else if (
        typeof goal.key_result_area === "number" ||
        typeof goal.key_result_area === "string"
      ) {
        kraOption =
          kraOptions.find((k) => k.value === goal.key_result_area) || null;
      }
    }
    let quarterOption = null;
    if (goal.quarter) {
      quarterOption =
        quarterOptions.find((q) => q.value === goal.quarter) || null;
    }

    let performanceStandardOption = null;
    if (goal.performance_standard) {
      performanceStandardOption =
        performanceStandardOptions.find(
          (p) => p.value === goal.performance_standard
        ) || null;
    }

    let monthOption = null;
    if (goal.month) {
      monthOption = monthOptions.find((m) => m.value === goal.month) || null;
    }

    setEditForm({
      key_result_area: kraOption,
      activity: goal.activity || "",
      metric: goal.metric || "",
      stakeholder: goal.stakeholder || "",
      performance_standard: performanceStandardOption,
      quarter: quarterOption,
      year: goal.year || new Date().getFullYear(),
      week: goal.week || "",
      month: monthOption,
    });
    setEditError(null);
    setSelectedGoal(goal);
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
  };

  const handleEditFormChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const handleEditSelectChange = (selected, { name }) => {
    setEditForm({ ...editForm, [name]: selected });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setEditLoading(true);
    setEditError(null);
    try {
      const token = Cookies.get("token");
      const response = await axios.put(
        `${baseUrl}/api/goals/${selectedGoal.id}/`,
        {
          key_result_area_id: editForm.key_result_area
            ? editForm.key_result_area.value
            : null,
          activity: editForm.activity,
          metric: parseInt(editForm.metric),
          stakeholder: editForm.stakeholder,
          performance_standard: editForm.performance_standard
            ? editForm.performance_standard.value
            : null,
          quarter: editForm.quarter ? editForm.quarter.value : null,
          week:
            editForm.quarter?.value === "Weekly" || editForm.quarter?.value === "Bi-Weekly"
              ? parseInt(editForm.week)
              : null,
          month:
            editForm.quarter?.value === "Monthly"
              ? editForm.month
                ? parseInt(editForm.month.value)
                : null
              : null,
          year: editForm.year || new Date().getFullYear(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const updatedGoal = response.data;
      setGoals((prevGoals) =>
        prevGoals.map((g) => (g.id === updatedGoal.id ? updatedGoal : g))
      );
      setSelectedGoal(updatedGoal);
      setEditModalOpen(false);
      toast.success("Goal updated successfully!");
    } catch (err) {
      setEditError(err.message || "Could not update goal");
    } finally {
      setEditLoading(false);
    }
  };

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = Cookies.get("token");
        const response = await axios.get(`${baseUrl}/api/users/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setGoals(response?.data?.employee?.goals || []);
      } catch (err) {
        setError(
          err.response?.data?.message ||
          err.message ||
          "Failed to fetch profile"
        );
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [baseUrl]);

  useEffect(() => {
    if (goals && goals.length > 0) {
      const uniqueYears = [
        ...new Set(
          goals
            .map((goal) => goal.year)
            .filter((year) => year !== null && year !== undefined)
        ),
      ].sort((a, b) => b - a);

      if (uniqueYears.length > 0) {
        setAvailableYears(uniqueYears);
      }
    } else {
      setAvailableYears([]);
    }
  }, [goals]);

  const renderApprovalBadge = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved':
        return <span className="badge bg-success-subtle text-success border border-success-subtle">Approved</span>;
      case 'rejected':
        return <span className="badge bg-danger-subtle text-danger border border-danger-subtle">Rejected</span>;
      case 'pending':
        return (
          <span className="badge bg-warning-subtle text-warning border border-warning-subtle d-inline-flex align-items-center gap-1">
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            Pending
          </span>
        );
      default:
        return <span className="badge bg-secondary-subtle text-secondary">{status || 'Unknown'}</span>;
    }
  };

  return (
    <div data-sidebar-skin="dark" data-header-skin="light" data-navbar-brand-skin="dark" data-sidebar-state="expand">
      <Topbar />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content pb-0">
          {/* Header */}
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
            <div>
              <h4 className="fw-bold mb-1">Key Performance Indicators</h4>
              <p className="text-muted mb-0 fs-13">View and manage your performance goals</p>
            </div>

            <div className="d-flex align-items-center gap-3 flex-wrap">
              {/* Status Toggle */}
              <div className="btn-group btn-group-sm" role="group">
                <button
                  type="button"
                  className={`btn ${selectedStatus === 'active' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setSelectedStatus('active')}
                  title="Show Not Started & In Progress goals"
                >
                  Active
                </button>
                <button
                  type="button"
                  className={`btn ${selectedStatus === 'completed' ? 'btn-success' : 'btn-outline-success'}`}
                  onClick={() => setSelectedStatus('completed')}
                  title="Show Completed goals"
                >
                  Completed
                </button>
              </div>

              {/* Year Select */}
              <div className="d-flex align-items-center gap-2">
                <label className="form-label mb-0 fs-14 text-muted">Year:</label>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                  className="form-select form-select-sm"
                  style={{ width: 'auto' }}
                  title="Filter by year"
                >
                  {(availableYears.length ? availableYears : [selectedYear])
                    .sort((a, b) => a - b)
                    .map((y) => (
                      <option key={y} value={y}>
                        {y}
                      </option>
                    ))}
                </select>
              </div>

              {/* Quarter Select */}
              <div className="d-flex align-items-center gap-2">
                <label className="form-label mb-0 fs-14 text-muted">Quarter:</label>
                <select
                  value={selectedQuarter}
                  onChange={(e) => setSelectedQuarter(e.target.value)}
                  className="form-select form-select-sm"
                  style={{ width: 'auto' }}
                  title="Filter by quarter"
                >
                  <option value="">All</option>
                  <option value="Q1">Q1</option>
                  <option value="Q2">Q2</option>
                  <option value="Q3">Q3</option>
                  <option value="Q4">Q4</option>
                  <option value="Quarterly">Quarterly</option>
                  <option value="Bi-Weekly">Bi-Weekly</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Semi-Annually">Semi-Annually</option>
                  <option value="Annually">Annually</option>
                  <option value="Weekly">Weekly</option>
                </select>
              </div>
            </div>
          </div>

          {/* Main Content */}
          {loading ? (
            <div className="card shadow-sm p-5 text-center">
              <div className="spinner-border text-primary mx-auto mb-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="text-muted mb-0 fs-13">Loading KPIs...</p>
            </div>
          ) : error ? (
            <div className="alert alert-danger shadow-sm" role="alert">
              <i className="ti ti-alert-circle me-2" />
              {error}
            </div>
          ) : goals.length === 0 ? (
            <div className="card shadow-sm p-5 text-center text-muted">
              <i className="ti ti-target-off fs-36 mb-2 text-secondary opacity-50" />
              No KPIs found.
            </div>
          ) : (
            <div className="card shadow-sm mb-4">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Activity</th>
                      <th>Stakeholder</th>
                      <th>KPI Metric</th>
                      <th>Status</th>
                      <th>Period</th>
                      <th style={{ width: '120px' }}>RAG</th>
                      <th className="text-center" style={{ width: '140px' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const filteredGoals = goals
                        .filter((g) =>
                          g.year !== undefined && g.year !== null
                            ? g.year === selectedYear
                            : true
                        )
                        .filter(
                          (goal) =>
                            !selectedQuarter || goal.quarter === selectedQuarter
                        )
                        .filter((goal) => {
                          if (selectedStatus === "completed") {
                            return goal.status === "completed";
                          }
                          return (
                            goal.status === "not_started" ||
                            goal.status === "in_progress" ||
                            goal.status == null
                          );
                        });

                      const groupedByKra = filteredGoals.reduce((acc, goal) => {
                        const kraName =
                          (goal.key_result_area &&
                            typeof goal.key_result_area === "object"
                            ? goal.key_result_area.name
                            : goal.key_result_area) || "Uncategorized";
                        if (!acc[kraName]) acc[kraName] = [];
                        acc[kraName].push(goal);
                        return acc;
                      }, {});

                      if (filteredGoals.length === 0) {
                        return (
                          <tr>
                            <td colSpan={7} className="text-center py-5 text-muted">
                              <i className="ti ti-target-off fs-36 d-block mb-2 text-secondary opacity-50" />
                              No KPIs found for the selected filters.
                            </td>
                          </tr>
                        );
                      }

                      return Object.entries(groupedByKra).map(
                        ([kraName, kraGoals]) => (
                          <React.Fragment key={kraName}>
                            <tr className="bg-light fw-bold">
                              <td colSpan={7} className="py-2 text-dark">
                                {(() => {
                                  const kraPercentage =
                                    kraGoals?.[0]?.key_result_area?.percentage ??
                                    kraGoals?.[0]?.kra?.percentage ??
                                    kraGoals?.[0]?.percentage ??
                                    0;
                                  return (
                                    <>
                                      KRA: <span className="text-primary">{kraName}</span>
                                      <span className="badge bg-secondary ms-2 fw-semibold">
                                        Weight: {kraPercentage}%
                                      </span>
                                    </>
                                  );
                                })()}
                              </td>
                            </tr>
                            {kraGoals.map((goal, idx) => (
                              <tr key={goal.id || `${kraName}-${idx}`}>
                                <td>
                                  {(() => {
                                    let activityStr =
                                      typeof goal.activity === "object" &&
                                        goal.activity !== null
                                        ? JSON.stringify(goal.activity)
                                        : goal.activity || "[No Activity]";
                                    const expandKey =
                                      goal.id || `${kraName}-${idx}`;
                                    const isExpanded =
                                      expandedActivities[expandKey];
                                    if (activityStr.length > 25) {
                                      return (
                                        <span>
                                          {isExpanded
                                            ? activityStr
                                            : activityStr.slice(0, 25) + "..."}
                                          <button
                                            type="button"
                                            onClick={() => toggleActivityExpansion(expandKey)}
                                            className="btn btn-link btn-sm p-0 ms-1 text-decoration-none fw-semibold"
                                          >
                                            {isExpanded ? " [less]" : " [more]"}
                                          </button>
                                        </span>
                                      );
                                    }
                                    return activityStr;
                                  })()}
                                </td>
                                <td>{goal.stakeholder}</td>
                                <td className="fw-semibold">{goal.metric}%</td>
                                <td>{renderApprovalBadge(goal.approval_status)}</td>
                                <td>{goal.quarter}</td>
                                <td>
                                  <span
                                    className="badge w-100 text-white"
                                    style={{ backgroundColor: goal.progress_indicator || '#6c757d' }}
                                  >
                                    {goal.rag_color || 'N/A'}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <div className="d-flex align-items-center justify-content-center gap-1">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-icon btn-light text-primary"
                                      title="Edit Goal"
                                      onClick={() => openEditModal(goal)}
                                    >
                                      <i className="ti ti-edit" />
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-icon btn-light text-danger"
                                      title="Delete Goal"
                                      onClick={() => handleDeleteGoal(goal)}
                                    >
                                      <i className="ti ti-trash" />
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-icon btn-light text-info"
                                      title="View Goal Details"
                                      onClick={() => handleViewGoal(goal)}
                                    >
                                      <i className="ti ti-eye" />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        )
                      );
                    })()}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="footer d-flex align-items-center justify-content-between flex-column flex-sm-row row-gap-2 border-top py-2 px-3">
          <p className="text-dark mb-0">
            2026 © <span className="link-primary">Casoe Technologies</span>, All Rights Reserved
          </p>
        </div>
      </div>

      {/* Goal Details & Progress History Modal */}
      {modalOpen && selectedGoal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content shadow-lg border-0">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">KPI Details</h5>
                <button type="button" className="btn-close" onClick={closeModal} aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="table-responsive border rounded mb-4">
                  <table className="table table-striped mb-0">
                    <tbody>
                      <tr>
                        <th style={{ width: '35%' }} className="text-muted fw-semibold fs-14">Key Result Area:</th>
                        <td className="fw-medium text-dark">{selectedGoal.key_result_area?.name || selectedGoal.key_result_area || "[No KRA]"}</td>
                      </tr>
                      <tr>
                        <th className="text-muted fw-semibold fs-14">Key Result Area Weight:</th>
                        <td className="fw-medium text-dark">{selectedGoal.key_result_area?.percentage || selectedGoal.percentage}%</td>
                      </tr>
                      <tr>
                        <th className="text-muted fw-semibold fs-14">Activity:</th>
                        <td className="fw-medium text-dark" style={{ whiteSpace: 'pre-wrap' }}>
                          {typeof selectedGoal.activity === "object" && selectedGoal.activity !== null
                            ? JSON.stringify(selectedGoal.activity)
                            : selectedGoal.activity || "[No Activity]"}
                        </td>
                      </tr>
                      <tr>
                        <th className="text-muted fw-semibold fs-14">KPI Metric:</th>
                        <td className="fw-medium text-dark">{selectedGoal.metric}%</td>
                      </tr>
                      <tr>
                        <th className="text-muted fw-semibold fs-14">Stakeholder:</th>
                        <td className="fw-medium text-dark">{selectedGoal.stakeholder}</td>
                      </tr>
                      <tr>
                        <th className="text-muted fw-semibold fs-14">Period:</th>
                        <td className="fw-medium text-dark">{selectedGoal.quarter}</td>
                      </tr>
                      <tr>
                        <th className="text-muted fw-semibold fs-14">RAG Color:</th>
                        <td>
                          <span
                            className="badge text-white px-3 py-2"
                            style={{ backgroundColor: selectedGoal.progress_indicator || '#6c757d' }}
                          >
                            {selectedGoal.rag_color || 'N/A'}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <th className="text-muted fw-semibold fs-14">Status:</th>
                        <td className="fw-medium text-dark">
                          {selectedGoal.status
                            ? selectedGoal.status.charAt(0).toUpperCase() + selectedGoal.status.slice(1).replace(/_/g, " ")
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th className="text-muted fw-semibold fs-14">Approval Status:</th>
                        <td>{renderApprovalBadge(selectedGoal.approval_status)}</td>
                      </tr>
                      <tr>
                        <th className="text-muted fw-semibold fs-14">Due Date:</th>
                        <td className="fw-medium text-dark">
                          {selectedGoal.completion_date
                            ? new Date(selectedGoal.completion_date).toLocaleDateString("en-GB")
                            : "N/A"}
                        </td>
                      </tr>
                      {selectedGoal.approval_status === "rejected" && selectedGoal.rejected_reason && (
                        <tr>
                          <th className="text-muted fw-semibold fs-14">Rejection Reason:</th>
                          <td className="text-danger fw-semibold">{selectedGoal.rejected_reason}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Progress History Section */}
                {selectedGoal.approval_status === "approved" && (
                  <div className="card border-0 bg-light">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
                        <h6 className="fw-bold text-dark mb-0">Progress History</h6>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary d-inline-flex align-items-center gap-1"
                          onClick={openProgressModal}
                          disabled={selectedGoal.status === "completed"}
                        >
                          <i className="ti ti-plus" /> Update Progress
                        </button>
                      </div>

                      {progressLoading ? (
                        <div className="text-center py-3">
                          <div className="spinner-border spinner-border-sm text-primary mb-1" role="status" />
                          <p className="text-muted fs-12 mb-0">Loading progress history...</p>
                        </div>
                      ) : progressError ? (
                        <div className="alert alert-danger py-2 fs-13 mb-0" role="alert">
                          {progressError}
                        </div>
                      ) : (
                        <div className="table-responsive border rounded bg-white">
                          <table className="table table-hover table-sm mb-0">
                            <thead className="table-light">
                              <tr>
                                <th>Comment</th>
                                <th>Status</th>
                                <th>Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!selectedGoal.progress_history || selectedGoal.progress_history.length === 0 ? (
                                <tr>
                                  <td colSpan={3} className="text-center py-3 text-muted fs-13">
                                    No progress history.
                                  </td>
                                </tr>
                              ) : (
                                selectedGoal.progress_history.map((ph, i) => (
                                  <tr key={ph.id || i}>
                                    <td className="fs-13">{ph.comments}</td>
                                    <td className="fs-13 text-capitalize">{ph.status}</td>
                                    <td className="fs-13 text-muted">
                                      {ph.reported_at
                                        ? new Date(ph.reported_at).toLocaleString("en-US", {
                                          year: "numeric",
                                          month: "short",
                                          day: "2-digit",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })
                                        : "-"}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Progress Update Modal */}
      {progressModalOpen && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1060 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg border-0">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">Update Progress</h5>
                <button type="button" className="btn-close" onClick={closeProgressModal} aria-label="Close" />
              </div>
              <form onSubmit={handleProgressSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label fw-medium">Status <span className="text-danger">*</span></label>
                    <select
                      name="status"
                      value={progressForm.status}
                      onChange={handleProgressFormChange}
                      className="form-select"
                      required
                    >
                      <option value="in_progress">In Progress</option>
                      <option value="completed">Completed</option>
                    </select>
                  </div>

                  {progressForm.status === "completed" && (
                    <div className="mb-3">
                      <label className="form-label fw-medium">
                        Score <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        name="score"
                        min={0}
                        max={selectedGoal.metric}
                        value={progressForm.score || ""}
                        onChange={handleProgressFormChange}
                        className="form-control"
                        required
                        placeholder={`Max: ${selectedGoal.metric}`}
                      />
                      {progressForm.score > selectedGoal.metric && (
                        <div className="text-danger fs-12 mt-1">
                          Score cannot be greater than the goal metric ({selectedGoal.metric}).
                        </div>
                      )}
                    </div>
                  )}

                  <div className="mb-3">
                    <label className="form-label fw-medium">Deliverable / Comment <span className="text-danger">*</span></label>
                    <textarea
                      name="comments"
                      required
                      value={progressForm.comments}
                      onChange={handleProgressFormChange}
                      className="form-control"
                      rows={3}
                      placeholder="Enter deliverable summary or progress comments..."
                    />
                  </div>

                  {progressForm.status === "completed" && (
                    <div className="mb-3">
                      <label className="form-label fw-medium">Supporting Document</label>
                      <input
                        type="file"
                        name="file"
                        onChange={handleProgressFormChange}
                        accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.webp"
                        className="form-control"
                      />
                    </div>
                  )}

                  {progressSubmitError && (
                    <div className="alert alert-danger py-2 fs-13 mb-0" role="alert">
                      {progressSubmitError}
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="button" onClick={closeProgressModal} className="btn btn-secondary">
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary d-inline-flex align-items-center gap-1"
                    disabled={
                      progressSubmitting ||
                      (progressForm.status === "completed" &&
                        progressForm.score > selectedGoal.metric)
                    }
                  >
                    {progressSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                        Updating...
                      </>
                    ) : (
                      'Submit Progress'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Edit Goal Modal */}
      {editModalOpen && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1060 }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content shadow-lg border-0">
              <div className="modal-header">
                <div>
                  <h5 className="modal-title fw-bold">Edit KPI Details</h5>
                  <p className="text-muted fs-12 mb-0">Refine your key performance indicator settings</p>
                </div>
                <button type="button" className="btn-close" onClick={closeEditModal} aria-label="Close" />
              </div>
              <form onSubmit={handleEditSubmit}>
                <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                  {/* Year */}
                  <div className="mb-3">
                    <label className="form-label fw-medium">Year <span className="text-danger">*</span></label>
                    <select
                      name="year"
                      value={editForm.year}
                      onChange={handleEditFormChange}
                      required
                      className="form-select"
                      disabled={editLoading}
                    >
                      {[new Date().getFullYear(), new Date().getFullYear() + 1].map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* KRA & Period */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <label className="form-label fw-medium">Key Result Area <span className="text-danger">*</span></label>
                      <Select
                        name="key_result_area"
                        value={editForm.key_result_area}
                        onChange={handleEditSelectChange}
                        options={kraOptions}
                        placeholder={fetchingKRAs ? "Loading KRAs..." : "Select Key Result Area"}
                        isDisabled={editLoading || fetchingKRAs}
                        styles={selectStyles}
                        menuPortalTarget={document.body}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-medium">Period <span className="text-danger">*</span></label>
                      <Select
                        name="quarter"
                        value={editForm.quarter}
                        onChange={handleEditSelectChange}
                        options={quarterOptions}
                        placeholder="Select Period"
                        isDisabled={editLoading}
                        styles={selectStyles}
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </div>

                  {/* Conditional Weekly/Bi-Weekly */}
                  {(editForm.quarter?.value === "Weekly" || editForm.quarter?.value === "Bi-Weekly") && (
                    <div className="mb-3">
                      <label className="form-label fw-medium">
                        {editForm.quarter?.value === "Bi-Weekly" ? "Starting Week Number" : "Week Number"} <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        name="week"
                        value={editForm.week}
                        onChange={handleEditFormChange}
                        required
                        className="form-control"
                        placeholder="Enter week number (1-52)"
                        min="1"
                        max="52"
                        disabled={editLoading}
                      />
                    </div>
                  )}

                  {/* Conditional Monthly */}
                  {editForm.quarter?.value === "Monthly" && (
                    <div className="mb-3">
                      <label className="form-label fw-medium">Month <span className="text-danger">*</span></label>
                      <Select
                        name="month"
                        value={editForm.month}
                        onChange={handleEditSelectChange}
                        options={monthOptions}
                        placeholder="Select Month"
                        isDisabled={editLoading}
                        styles={selectStyles}
                        menuPortalTarget={document.body}
                      />
                    </div>
                  )}

                  {/* Activity */}
                  <div className="mb-3">
                    <label className="form-label fw-medium">Activity <span className="text-danger">*</span></label>
                    <textarea
                      name="activity"
                      value={editForm.activity}
                      onChange={handleEditFormChange}
                      required
                      className="form-control"
                      placeholder="Describe activity..."
                      rows={3}
                      disabled={editLoading}
                    />
                  </div>

                  {/* Performance Standard */}
                  <div className="mb-3">
                    <label className="form-label fw-medium">Performance Standard <span className="text-danger">*</span></label>
                    <Select
                      name="performance_standard"
                      value={editForm.performance_standard}
                      onChange={handleEditSelectChange}
                      options={performanceStandardOptions}
                      placeholder="Select Performance Standard"
                      isDisabled={editLoading}
                      styles={selectStyles}
                      menuPortalTarget={document.body}
                    />
                  </div>

                  {/* Metric & Stakeholder */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <label className="form-label fw-medium">Metric <span className="text-danger">*</span></label>
                      <input
                        type="number"
                        name="metric"
                        value={editForm.metric}
                        onChange={handleEditFormChange}
                        required
                        className="form-control"
                        placeholder="Enter metric value"
                        min="0"
                        disabled={editLoading}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-medium">Stakeholder <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="stakeholder"
                        value={editForm.stakeholder}
                        onChange={handleEditFormChange}
                        required
                        className="form-control"
                        placeholder="Enter stakeholder name"
                        disabled={editLoading}
                      />
                    </div>
                  </div>

                  {editError && (
                    <div className="alert alert-danger py-2 fs-13 mb-0" role="alert">
                      {editError}
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="button" onClick={closeEditModal} className="btn btn-secondary" disabled={editLoading}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={editLoading}>
                    {editLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                        Saving...
                      </>
                    ) : (
                      'Save Changes'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyGoals;